import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCount } from '@app/src/api/fetchHooks'
import Permissions, { usePermissions } from '@app/src/auth/permissions'
import useAiScreeningEnabled from '@app/src/hooks/useAiScreeningEnabled'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'

const useShowScreenedRequests = (): boolean => {
  const { hasPermission } = usePermissions()
  const isTransparency = hasPermission(Permissions.TRANSPARENCY_USER)
  const isAiScreeningEnabled = useAiScreeningEnabled({ enabled: !isTransparency })

  const { count: screenedRequestsCount = 0 } = useFetchCount({
    key: FetchKey.Response,
    endpoint: endpoints.responsesCount,
    payload: [{ name: 'isScraped', filters: [{ operator: Operators.EqualTo, value: true }] }],
    shouldShowErrorNotification: false,
    options: { enabled: isTransparency },
  })

  return isTransparency ? screenedRequestsCount > 0 : isAiScreeningEnabled
}

export default useShowScreenedRequests
